import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { searchAPI, setResumeData } from 'modules/Onboarding/actions'
import { SpinWrapper } from 'modules/Onboarding/Register/Education/style'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import { SubHeading1 } from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import ProjectForm from 'modules/Resume/DrawerComponents/ProjectDetails/ProjectForm'
import {
  ButtonLocal,
  Text,
} from 'modules/Resume/DrawerComponents/ProjectDetails/style'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { searchConfig } from 'utils/config'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getStudentData } from '../../actions'
import instituteRequest from 'utils/instituteRequest'

const ProjectDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  instituteName,
  listOfStudentSkills,
  getListOfSkills,
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [project, setProject] = useState([])
  const [corporateName, setCorporateName] = useState([])
  const [corporateId, setCorporateId] = useState('')
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [skillLoading, setSkillLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [shown, setShown] = useState([])
  const [updated, setUpdated] = useState(false)
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    if (!tpoConfig || !tpoConfig.tpoApprovalConfig || !tpoConfig.tpoApprovalConfig.fields) {
      setFrozenFieldsMap({})
      setIsAddNewFrozen(false)
      return
    }

    const approvedProjects = studentFormData?.resume?.projects || []
    const frozen = {}
    const fields = tpoConfig.tpoApprovalConfig.fields
    
    const addNewConfig = fields['projects.addNew']
    const shouldFreezeAddNew = (addNewConfig?.freezeAfterVerification || addNewConfig?.freezeAfterApproval) && approvedProjects.length >= 1
    setIsAddNewFrozen(shouldFreezeAddNew)

    approvedProjects.forEach((project) => {
      if (!project.id) return

      const projectId = project.id
      frozen[projectId] = {}

      const fieldMappings = {
        'title': 'title',
        'organization': 'organization',
        'started_in': 'started_in',
        'ended_in': 'ended_in', 
        'description': 'description',
        'skill_set': 'skill_set',
        'certificate': 'certifications',
        'function': 'function',
        'role': 'role',
        'industry': 'industry',
        'awards': 'awards'
      }

      Object.entries(fieldMappings).forEach(([uiField, configFields]) => {
        const configFieldArray = Array.isArray(configFields) ? configFields : [configFields]
        
        const shouldFreeze = configFieldArray.some(configField => {
          const fullFieldName = `projects.${configField}`
          const fieldConfig = fields[fullFieldName]
          return fieldConfig && (fieldConfig.freezeAfterVerification || fieldConfig.freezeAfterApproval)
        })

        if (shouldFreeze) {
          const fieldValue = project[uiField]
          
          // For started_in and ended_in fields, freeze based on TPO config alone (no value check needed)
          // For certificate and other fields, only freeze if they have values
          if (uiField === 'started_in' || uiField === 'ended_in') {
            frozen[projectId][uiField] = true
          } else {
            const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                             (!Array.isArray(fieldValue) || fieldValue.length > 0) &&
                             (typeof fieldValue !== 'object' || Object.keys(fieldValue || {}).length > 0)

            if (hasValue) {
              frozen[projectId][uiField] = true
            }
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.resume?.projects])

  useEffect(() => {
    try {
      let projectList = []
      
      const approvedProjects = studentFormData?.resume?.projects || []
      const pendingProjects = (pendingData && pendingData?.resume?.projects) || []
      
      const pendingMap = new Map()
      pendingProjects.forEach(p => {
        if (p.id && !p.id.startsWith('temp-')) {
          pendingMap.set(p.id, p)
        }
      })
      
      const mergedProjects = approvedProjects.map(approvedProj => {
        const pendingProj = pendingMap.get(approvedProj.id)
        
        if (pendingProj && pendingProj._pendingFields) {
          const merged = { ...approvedProj }
          
          Object.keys(pendingProj._pendingFields).forEach(fieldName => {
            merged[fieldName] = pendingProj._pendingFields[fieldName].value
          })
          
          merged._hasPendingChanges = true
          merged._pendingFields = pendingProj._pendingFields
          
          return merged
        }
        
        return approvedProj
      })
      
      const newPendingProjects = pendingProjects.filter(p => 
        p._isNew || (p.id && p.id.startsWith('temp-'))
      )
      
      const allProjects = [...mergedProjects, ...newPendingProjects]
      
      allProjects.map((data, index) => {
        let formName = 'project_' + index
        const formattedDescription = Array.isArray(data?.description)
          ? data.description.map(item => `${item}`).join('\n')
          : data?.description
        form.setFieldsValue({
          [formName]: {
            id: data?.id,
            temp_id: data?.temp_id,
            corporateId: data?.corporateId,
            organization: data?.organization,
            title: data?.title,
            started_in: data?.started_in,
            ended_in: data?.ended_in,
            function: data?.function,
            role: data?.role,
            industry: data?.industry,
            description: formattedDescription,
            skill_set: data?.skill_set,
            certificate: data?.certificate,
            awards: data?.awards,
            isDelete: false,
            shown: true,
          },
        })
        return projectList.push({
          component: ProjectForm,
          formName: formName,
        })
      })
      setProject(projectList)
    } catch (error) {
      console.error('Error in ProjectDrawer useEffect:', error)
      setProject([])
    }
  }, [studentFormData, pendingData])

  const projectHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())

    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'project_' + `${lastValue + 1}`
    arr.push({
      component: ProjectForm,
      formName: formName,
    })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      return setProject([...project, ...arr])
    }
    if (isDelete) {
      form.setFieldValue([[deleteForm], 'isDelete'], true)
      setIsUpdateButtonEnabled(false)
      let updatedList = project?.filter(data => data?.formName !== deleteForm)
      return setProject(updatedList)
    }
  }
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const submitHandler = async () => {
    if (submitLoading) {
      return
    }
    
    setSubmitLoading(true)
    
    try {
      let project = []
      let internship = []
      const values = await form.getFieldValue()
      const errorList = []
      await form
        .validateFields()
        .then()
        .catch(err => {
          errorList.push(err?.errorFields)
        })
      if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('project') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          project.push({
            ...obj,
            awards: [],
          })
        } else if (
          name.includes('internship') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          internship.push({
            ...obj,
            awards: [],
          })
        }
      })

      let awardProjectData = []
      Object.entries(project).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (name.includes('project_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardProjectData.push(load)
          }
        })
      })

      for (let i = 0; i < project.length; i++) {
        for (const [key, value] of Object.entries(awardProjectData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              project[i].awards.push(value1)
            }
          }
        }
      }

      project = project.map(proj => ({
        ...proj,
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }))

      const uniqueProjects = []
      const seenIds = new Set()
      const seenKeys = new Set()
      
      project.forEach(proj => {
        if (proj.id && !proj.id.startsWith('temp-')) {
          if (seenIds.has(proj.id)) {
            return
          }
          seenIds.add(proj.id)
          uniqueProjects.push(proj)
        } else {
          const key = JSON.stringify({
            title: proj.title,
            organization: proj.organization,
            started_in: proj.started_in,
            ended_in: proj.ended_in
          })
          if (!seenKeys.has(key)) {
            seenKeys.add(key)
            uniqueProjects.push(proj)
          }
        }
      })

      let payload = {
        refreshRanking: true,
        checkForApproval: true,
        checkDeleteSection: ['projects'],
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student,
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              marks: studentFormData?.currentCourse?.marks ?? 0,
            }
          : {},
        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          projects: uniqueProjects,
        },
      }
      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      studentFormData?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })
      uniqueProjects.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0
        ) {
          delete uniqueProjects[index]?.certificate
        }

        delete uniqueProjects[index]?.startMonth
        delete uniqueProjects[index]?.startYear
        delete uniqueProjects[index]?.endMonth
        delete uniqueProjects[index]?.endYear
      })
      if (payload?.currentCourse?.skills === null) {
        delete payload?.currentCourse?.skills
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      const response = await updateStudentData(payload);
      await dispatch(setResumeData(payload))
      
      dispatch(getStudentData()).catch(err => console.error('getStudentData error:', err))
      getPendingData().catch(err => console.error('getPendingData error:', err))
      
      setSubmitLoading(false)
      
      if (response?.success === true) {
        // Check if data was sent to pending or main table based on response
        const responseData = response?.response?.data
        const wentToPending = responseData?.pendingData || responseData?.approvalRequired || responseData?.message?.includes('approval')
        
        if (wentToPending) {
          SuccessMessage('Sent for Approval!')
        } else {
          SuccessMessage('Updated Successfully!')
        }
        setdrawerStatus(false)
        setUpdated(true)
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
    } catch (error) {
      console.error('Error in submitHandler:', error)
      ErrorMessage('An error occurred while submitting. Please try again.')
      setSubmitLoading(false)
    }
  }

  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const SkillsAPI = async (page, search) => {
    try {
      const results = await dispatch(
        searchAPI(searchConfig?.skills?.name, search, searchConfig?.skills)
      )
      let v = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }

      let updatedSkills = results || []
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills([...listOfAddedSkills, v])
        setListOfSkills([...updatedSkills, v])
      }
      const isExactMatch = updatedSkills?.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills([...listOfAddedSkills, v])
          setListOfSkills([...updatedSkills, v])
        } else {
          setListOfSkills(updatedSkills)
        }
      }
    } catch (error) {
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('SkillsAPI timeout')), 5000)
        )
        
        await Promise.race([SkillsAPI(0), timeoutPromise])
      } catch (error) {
        console.error('SkillsAPI error:', error)
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])

  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler}
          id={'projectForm'}
          form={form}
          layout="vertical"
        >
          {!!project?.length &&
            project?.map((obj, index) => {
              const approvedProjects = studentFormData?.resume?.projects || []
              const pendingProjects = (pendingData && pendingData?.resume?.projects) || []
              
              const pendingMap = new Map()
              pendingProjects.forEach(p => {
                if (p.id && !p.id.startsWith('temp-')) {
                  pendingMap.set(p.id, p)
                }
              })
              
              const mergedProjects = approvedProjects.map(approvedProj => {
                const pendingProj = pendingMap.get(approvedProj.id)
                
                if (pendingProj && pendingProj._pendingFields) {
                  const merged = { ...approvedProj }
                  Object.keys(pendingProj._pendingFields).forEach(fieldName => {
                    merged[fieldName] = pendingProj._pendingFields[fieldName].value
                  })
                  merged._hasPendingChanges = true
                  merged._pendingFields = pendingProj._pendingFields
                  merged._requestId = pendingProj._requestId
                  return merged
                }
                return approvedProj
              })
              
              const newPendingProjects = pendingProjects.filter(p => 
                p._isNew || (p.id && p.id.startsWith('temp-'))
              )
              
              const allProjects = [...mergedProjects, ...newPendingProjects]
              
              // Get the project ID from the form data, not by array index
              const formData = form.getFieldValue(obj?.formName)
              let projectId = formData?.id
              if (!projectId) {
                projectId = formData?.temp_id
              }
              const currentProject = projectId ? allProjects.find(proj => proj.id === projectId || proj.temp_id === projectId) : null
              const frozenFields = projectId ? frozenFieldsMap[projectId] || {} : {}
              const pendingFields = currentProject?._pendingFields || {}
              const _requestId = currentProject?._requestId
              
              return (
                <obj.component
                  key={index + 'project'}
                  form={form}
                  onRemove={projectHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  listOfStudentSkills={listOfStudentSkills}
                  getListOfSkills={getListOfSkills}
                  setCorporateName={setCorporateName}
                  corporateName={corporateName}
                  setCorporateId={setCorporateId}
                  corporateId={corporateId}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  skillLoading={skillLoading}
                  setSkillLoading={setSkillLoading}
                  listOfSkills={listOfSkills}
                  SkillsAPI={SkillsAPI}
                  shown={shown}
                  frozenFields={frozenFields}
                  pendingFields={pendingFields}
                  _requestId={_requestId}
                />
              )
            })}
        </Form>
        <SubHeading1>Note:</SubHeading1>
        <SubHeading1>
          Please fill in all details in the section below to ensure exposure to
          maximum number of corporates
        </SubHeading1>
        <ButtonLocal 
          onClick={() => !isAddNewFrozen && projectHandler(true, false, null)}
          disabled={isAddNewFrozen}
          style={{ 
            opacity: isAddNewFrozen ? 0.5 : 1, 
            cursor: isAddNewFrozen ? 'not-allowed' : 'pointer' 
          }}
        >
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add Project</Text>
          </Control>
        </ButtonLocal>
        {studentFormData?.resume?.projects?.length > 0 && skillLoading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'projectForm'}
          htmlType="submit"
          text={'Update'}
          disabled={isUpdateButtonEnabled || submitLoading}
          loading={submitLoading}
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      width="675px"
      title={'Project Detail'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  )
}

export default ProjectDrawer
